<span [ngClass]="{disabled: disabled}" class="icon-wrapper" *ngIf="iconType">
  <ng-container [ngSwitch]="iconType">
    <!--Bell-->
    <svg
      *ngSwitchCase="IconsType.Bell"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.5146 16L6.6946 14.818C7.0726 14.44 7.2806 13.938 7.2806 13.404V8.72696C7.2806 7.36996 7.8706 6.07296 8.9006 5.17096C9.9386 4.26096 11.2606 3.86096 12.6376 4.04196C14.9646 4.35096 16.7196 6.45496 16.7196 8.93695V13.404C16.7196 13.938 16.9276 14.44 17.3046 14.817L18.4856 16H5.5146ZM13.9996 18.341C13.9996 19.24 13.0836 20 11.9996 20C10.9156 20 9.9996 19.24 9.9996 18.341V18H13.9996V18.341ZM20.5206 15.208L18.7196 13.404V8.93696C18.7196 5.45596 16.2176 2.49896 12.8996 2.05996C10.9776 1.80396 9.0376 2.39096 7.5826 3.66696C6.1186 4.94896 5.2806 6.79296 5.2806 8.72696L5.2796 13.404L3.4786 15.208C3.0096 15.678 2.8706 16.377 3.1246 16.99C3.3796 17.604 3.9726 18 4.6366 18H7.9996V18.341C7.9996 20.359 9.7936 22 11.9996 22C14.2056 22 15.9996 20.359 15.9996 18.341V18H19.3626C20.0266 18 20.6186 17.604 20.8726 16.991C21.1276 16.377 20.9896 15.677 20.5206 15.208Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Log Out-->
    <svg
      *ngSwitchCase="IconsType.LogOut"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 5C8 5.55 7.55 6 7 6H6V18H7C7.55 18 8 18.45 8 19C8 19.55 7.55 20 7 20H5C4.45 20 4 19.55 4 19V5C4 4.45 4.45 4 5 4H7C7.55 4 8 4.45 8 5ZM18.0039 7.4248L20.8179 11.4248C21.0679 11.7788 21.0599 12.2538 20.7999 12.5998L17.7999 16.5998C17.6039 16.8618 17.3029 16.9998 16.9989 16.9998C16.7909 16.9998 16.5799 16.9348 16.3999 16.7998C15.9579 16.4688 15.8689 15.8418 16.1999 15.4008L18.0009 12.9998H17.9999H9.9999C9.4479 12.9998 8.9999 12.5528 8.9999 11.9998C8.9999 11.4468 9.4479 10.9998 9.9999 10.9998H17.9999C18.0164 10.9998 18.0317 11.0044 18.0472 11.0089C18.0598 11.0127 18.0724 11.0165 18.0859 11.0178L16.3679 8.5748C16.0499 8.1238 16.1589 7.4998 16.6109 7.1818C17.0619 6.8628 17.6859 6.9728 18.0039 7.4248Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Facebook-->
    <svg
      *ngSwitchCase="IconsType.Facebook"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17 3.5C17 3.224 16.775 3 16.5 3H14C11.238 3 9 5.015 9 7.5V10.2H6.5C6.224 10.2 6 10.424 6 10.7V13.3C6 13.576 6.224 13.8 6.5 13.8H9V20.5C9 20.776 9.224 21 9.5 21H12.5C12.775 21 13 20.776 13 20.5V13.8H15.619C15.844 13.8 16.041 13.65 16.102 13.434L16.823 10.834C16.912 10.516 16.672 10.2 16.342 10.2H13V7.5C13 7.003 13.447 6.6 14 6.6H16.5C16.775 6.6 17 6.376 17 6.1V3.5Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Instagram-->
    <svg
      *ngSwitchCase="IconsType.Instagram"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.947 8.30499C20.9369 7.54761 20.7951 6.79776 20.528 6.08899C20.2964 5.49114 19.9425 4.94819 19.4892 4.49482C19.0358 4.04145 18.4929 3.68764 17.895 3.45599C17.1953 3.19334 16.4562 3.05133 15.709 3.03599C14.747 2.99299 14.442 2.98099 12 2.98099C9.55801 2.98099 9.24501 2.98099 8.29001 3.03599C7.54317 3.05144 6.80436 3.19346 6.10501 3.45599C5.50707 3.68748 4.96403 4.04123 4.51064 4.49462C4.05725 4.94801 3.7035 5.49105 3.47201 6.08899C3.20884 6.78812 3.06713 7.5271 3.05301 8.27399C3.01001 9.23699 2.99701 9.54199 2.99701 11.984C2.99701 14.426 2.99701 14.738 3.05301 15.694C3.06801 16.442 3.20901 17.18 3.47201 17.881C3.70389 18.4787 4.05791 19.0216 4.51145 19.4748C4.96499 19.928 5.50807 20.2816 6.10601 20.513C6.80344 20.7862 7.54238 20.9384 8.29101 20.963C9.25401 21.006 9.55901 21.019 12.001 21.019C14.443 21.019 14.756 21.019 15.711 20.963C16.4582 20.9483 17.1974 20.8066 17.897 20.544C18.4947 20.3121 19.0375 19.9582 19.4909 19.5048C19.9442 19.0515 20.2981 18.5087 20.53 17.911C20.793 17.211 20.934 16.473 20.949 15.724C20.992 14.762 21.005 14.457 21.005 12.014C21.003 9.57199 21.003 9.26199 20.947 8.30499ZM11.994 16.602C9.44001 16.602 7.37101 14.533 7.37101 11.979C7.37101 9.42499 9.44001 7.35599 11.994 7.35599C13.2201 7.35599 14.396 7.84305 15.263 8.71003C16.1299 9.57701 16.617 10.7529 16.617 11.979C16.617 13.2051 16.1299 14.381 15.263 15.2479C14.396 16.1149 13.2201 16.602 11.994 16.602ZM16.801 8.26299C16.6594 8.26312 16.5192 8.23533 16.3883 8.1812C16.2575 8.12707 16.1386 8.04767 16.0385 7.94754C15.9383 7.84741 15.8589 7.72852 15.8048 7.59768C15.7507 7.46683 15.7229 7.32659 15.723 7.18499C15.723 7.04349 15.7509 6.90337 15.805 6.77265C15.8592 6.64192 15.9385 6.52314 16.0386 6.42308C16.1387 6.32302 16.2574 6.24366 16.3882 6.18951C16.5189 6.13536 16.659 6.10749 16.8005 6.10749C16.942 6.10749 17.0821 6.13536 17.2129 6.18951C17.3436 6.24366 17.4624 6.32302 17.5624 6.42308C17.6625 6.52314 17.7418 6.64192 17.796 6.77265C17.8501 6.90337 17.878 7.04349 17.878 7.18499C17.878 7.78099 17.396 8.26299 16.801 8.26299Z"
        [attr.fill]="color"
      ></path>
      <path
        d="M11.994 14.982C13.6525 14.982 14.997 13.6375 14.997 11.979C14.997 10.3205 13.6525 8.97599 11.994 8.97599C10.3355 8.97599 8.99101 10.3205 8.99101 11.979C8.99101 13.6375 10.3355 14.982 11.994 14.982Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Twitter-->
    <svg
      *ngSwitchCase="IconsType.Twitter"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M 2.3671875 3 L 9.4628906 13.140625 L 2.7402344 21 L 5.3808594 21 L 10.644531 14.830078 L 14.960938 21 L 21.871094 21 L 14.449219 10.375 L 20.740234 3 L 18.140625 3 L 13.271484 8.6875 L 9.2988281 3 L 2.3671875 3 z M 6.2070312 5 L 8.2558594 5 L 18.033203 19 L 16.001953 19 L 6.2070312 5 z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--YouTube-->
    <svg
      *ngSwitchCase="IconsType.YouTube"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.593 7.20301C21.4791 6.78041 21.2565 6.39501 20.9474 6.08518C20.6383 5.77534 20.2534 5.55187 19.831 5.43701C18.265 5.00701 12 5.00001 12 5.00001C12 5.00001 5.73602 4.99301 4.16902 5.40401C3.74695 5.52415 3.36285 5.75078 3.05359 6.06214C2.74433 6.3735 2.52031 6.75913 2.40302 7.18201C1.99002 8.74801 1.98602 11.996 1.98602 11.996C1.98602 11.996 1.98202 15.26 2.39202 16.81C2.62202 17.667 3.29702 18.344 4.15502 18.575C5.73702 19.005 11.985 19.012 11.985 19.012C11.985 19.012 18.25 19.019 19.816 18.609C20.2385 18.4943 20.6238 18.2714 20.9337 17.9622C21.2436 17.653 21.4674 17.2682 21.583 16.846C21.997 15.281 22 12.034 22 12.034C22 12.034 22.02 8.76901 21.593 7.20301ZM9.99603 15.005L10.001 9.00501L15.208 12.01L9.99603 15.005Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--LinkedIn-->
    <svg
      *ngSwitchCase="IconsType.LinkedIn"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 5.25C3 4.008 4.008 3 5.25 3C6.492 3 7.5 4.008 7.5 5.25C7.5 6.492 6.492 7.5 5.25 7.5C4.008 7.5 3 6.492 3 5.25ZM15.1504 8.4004C11.9194 8.4004 9.2994 11.0044 9.2994 14.2144V20.0994C9.2994 20.5964 9.7034 21.0004 10.2004 21.0004H12.2994C12.7964 21.0004 13.2004 20.5964 13.2004 20.0994V14.2144C13.2004 13.0784 14.1844 12.1704 15.3524 12.2874C16.3664 12.3884 17.0994 13.3154 17.0994 14.3344V20.0994C17.0994 20.5964 17.5034 21.0004 18.0004 21.0004H20.0994C20.5964 21.0004 21.0004 20.5964 21.0004 20.0994V14.2144C21.0004 11.0044 18.3804 8.4004 15.1504 8.4004ZM6.5996 9.2998H3.9006C3.4036 9.2998 2.9996 9.7028 2.9996 10.1998V20.0998C2.9996 20.5968 3.4036 20.9998 3.9006 20.9998H6.5996C7.0966 20.9998 7.4996 20.5968 7.4996 20.0998V10.1998C7.4996 9.7028 7.0966 9.2998 6.5996 9.2998Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Menu-->
    <svg
      *ngSwitchCase="IconsType.Menu"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.9483 6H20.0513C20.5733 6 21.0003 6.427 21.0003 6.949V7.051C21.0003 7.573 20.5733 8 20.0513 8H3.9483C3.4263 8 3.0003 7.573 3.0003 7.051V6.949C3.0003 6.427 3.4263 6 3.9483 6ZM20.0513 11H3.9483C3.4263 11 3.0003 11.427 3.0003 11.949V12.051C3.0003 12.573 3.4263 13 3.9483 13H20.0513C20.5733 13 21.0003 12.573 21.0003 12.051V11.949C21.0003 11.427 20.5733 11 20.0513 11ZM20.0513 16H3.9483C3.4263 16 3.0003 16.427 3.0003 16.949V17.051C3.0003 17.573 3.4263 18 3.9483 18H20.0513C20.5733 18 21.0003 17.573 21.0003 17.051V16.949C21.0003 16.427 20.5733 16 20.0513 16Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Close-->
    <svg
      *ngSwitchCase="IconsType.Close"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4141 12L17.7071 7.70701C18.0981 7.31601 18.0981 6.68401 17.7071 6.29301C17.3161 5.90201 16.6841 5.90201 16.2931 6.29301L12.0001 10.586L7.7071 6.29301C7.3161 5.90201 6.6841 5.90201 6.2931 6.29301C5.9021 6.68401 5.9021 7.31601 6.2931 7.70701L10.5861 12L6.2931 16.293C5.9021 16.684 5.9021 17.316 6.2931 17.707C6.4881 17.902 6.7441 18 7.0001 18C7.2561 18 7.5121 17.902 7.7071 17.707L12.0001 13.414L16.2931 17.707C16.4881 17.902 16.7441 18 17.0001 18C17.2561 18 17.5121 17.902 17.7071 17.707C18.0981 17.316 18.0981 16.684 17.7071 16.293L13.4141 12Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--  Circle-close-->
    <svg
      *ngSwitchCase="IconsType.CircleClose"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        [attr.fill]="color"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.707 13.2929C15.098 13.6839 15.098 14.3159 14.707 14.7069C14.512 14.9019 14.256 14.9999 14 14.9999C13.744 14.9999 13.488 14.9019 13.293 14.7069L12 13.4139L10.707 14.7069C10.512 14.9019 10.256 14.9999 10 14.9999C9.744 14.9999 9.488 14.9019 9.293 14.7069C8.902 14.3159 8.902 13.6839 9.293 13.2929L10.586 11.9999L9.293 10.7069C8.902 10.3159 8.902 9.68388 9.293 9.29288C9.684 8.90188 10.316 8.90188 10.707 9.29288L12 10.5859L13.293 9.29288C13.684 8.90188 14.316 8.90188 14.707 9.29288C15.098 9.68388 15.098 10.3159 14.707 10.7069L13.414 11.9999L14.707 13.2929ZM12 1.99988C6.486 1.99988 2 6.48588 2 11.9999C2 17.5139 6.486 21.9999 12 21.9999C17.514 21.9999 22 17.5139 22 11.9999C22 6.48588 17.514 1.99988 12 1.99988Z"
        fill="#023665"
      ></path>
    </svg>


    <!--Case-->
    <svg
      *ngSwitchCase="IconsType.Case"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 18C20 18.551 19.551 19 19 19H17V9H19C19.551 9 20 9.449 20 10V18ZM4 18V10C4 9.449 4.449 9 5 9H7V19H5C4.449 19 4 18.551 4 18ZM10 5.5C10 5.224 10.224 5 10.5 5H13.5C13.776 5 14 5.224 14 5.5V7H10V5.5ZM9 19H15V9H9V19ZM19 7H16V5.5C16 4.122 14.878 3 13.5 3H10.5C9.122 3 8 4.122 8 5.5V7H5C3.346 7 2 8.346 2 10V18C2 19.654 3.346 21 5 21H19C20.654 21 22 19.654 22 18V10C22 8.346 20.654 7 19 7Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Grid-->
    <svg
      *ngSwitchCase="IconsType.Grid"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 19V15H19L19.001 19H15ZM19 13H15C13.897 13 13 13.897 13 15V19C13 20.103 13.897 21 15 21H19C20.103 21 21 20.103 21 19V15C21 13.897 20.103 13 19 13ZM5 19V15H9L9.001 19H5ZM9 13H5C3.897 13 3 13.897 3 15V19C3 20.103 3.897 21 5 21H9C10.103 21 11 20.103 11 19V15C11 13.897 10.103 13 9 13ZM15 9V5H19L19.001 9H15ZM19 3H15C13.897 3 13 3.897 13 5V9C13 10.103 13.897 11 15 11H19C20.103 11 21 10.103 21 9V5C21 3.897 20.103 3 19 3ZM5 9V5H9L9.001 9H5ZM9 3H5C3.897 3 3 3.897 3 5V9C3 10.103 3.897 11 5 11H9C10.103 11 11 10.103 11 9V5C11 3.897 10.103 3 9 3Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Group-->
    <svg
      *ngSwitchCase="IconsType.Group"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 10C18 9.449 17.552 9 17 9C16.448 9 16 9.449 16 10C16 10.551 16.448 11 17 11C17.552 11 18 10.551 18 10ZM20 10C20 11.654 18.654 13 17 13C15.346 13 14 11.654 14 10C14 8.346 15.346 7 17 7C18.654 7 20 8.346 20 10ZM11 7C11 5.897 10.103 5 9 5C7.897 5 7 5.897 7 7C7 8.103 7.897 9 9 9C10.103 9 11 8.103 11 7ZM13 7C13 9.206 11.206 11 9 11C6.794 11 5 9.206 5 7C5 4.794 6.794 3 9 3C11.206 3 13 4.794 13 7ZM13.94 15.046C14.809 14.374 15.879 14 17 14C19.757 14 22 16.243 22 19C22 19.552 21.553 20 21 20C20.447 20 20 19.552 20 19C20 17.346 18.654 16 17 16C16.317 16 15.668 16.234 15.144 16.649C15.688 17.645 16 18.787 16 20C16 20.552 15.553 21 15 21C14.447 21 14 20.552 14 20C14 17.243 11.757 15 9 15C6.243 15 4 17.243 4 20C4 20.552 3.553 21 3 21C2.447 21 2 20.552 2 20C2 16.14 5.141 13 9 13C10.927 13 12.673 13.783 13.94 15.046Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Calendar-->
    <svg
      *ngSwitchCase="IconsType.Calendar"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17C7.45 17 7 16.55 7 16ZM12 15H16C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17H12C11.45 17 11 16.55 11 16C11 15.45 11.45 15 12 15ZM18 20H6C5.449 20 5 19.551 5 19V13H19V19C19 19.551 18.551 20 18 20ZM6 6H7V7C7 7.55 7.45 8 8 8C8.55 8 9 7.55 9 7V6H15V7C15 7.55 15.45 8 16 8C16.55 8 17 7.55 17 7V6H18C18.551 6 19 6.449 19 7V11H5V7C5 6.449 5.449 6 6 6ZM18 4H17V3C17 2.45 16.55 2 16 2C15.45 2 15 2.45 15 3V4H9V3C9 2.45 8.55 2 8 2C7.45 2 7 2.45 7 3V4H6C4.346 4 3 5.346 3 7V19C3 20.654 4.346 22 6 22H18C19.654 22 21 20.654 21 19V7C21 5.346 19.654 4 18 4Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Campaigns-->
    <svg
      *ngSwitchCase="IconsType.Campaigns"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 14.4287H10.333C10.535 14.4287 10.732 14.4907 10.899 14.6037L16 18.1017V5.89871L10.899 9.39671C10.732 9.50971 10.535 9.57171 10.333 9.57171H6V14.4287ZM17 20.9997C16.802 20.9997 16.604 20.9417 16.435 20.8247L10.023 16.4287H5C4.448 16.4287 4 15.9817 4 15.4287V8.57171C4 8.01871 4.448 7.57171 5 7.57171H10.023L16.435 3.17471C16.74 2.96471 17.137 2.94171 17.466 3.11571C17.794 3.28771 18 3.62871 18 3.99971V19.9997C18 20.3707 17.794 20.7117 17.466 20.8847C17.32 20.9617 17.16 20.9997 17 20.9997Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--File-->
    <svg
      *ngSwitchCase="IconsType.File"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 14H9C8.448 14 8 13.552 8 13C8 12.448 8.448 12 9 12H12C12.552 12 13 12.448 13 13C13 13.552 12.552 14 12 14ZM8 17C8 16.448 8.448 16 9 16H15C15.553 16 16 16.448 16 17C16 17.552 15.553 18 15 18H9C8.448 18 8 17.552 8 17ZM17.4443 20H6.5553C6.2493 20 6.0003 19.776 6.0003 19.5V4.5C6.0003 4.224 6.2493 4 6.5553 4H12.0003V7.15C12.0003 8.722 13.2173 10 14.7143 10H18.0003V19.5C18.0003 19.776 17.7513 20 17.4443 20ZM14.0003 4.978L16.7423 8H14.7143C14.3203 8 14.0003 7.619 14.0003 7.15V4.978ZM19.7403 8.328L14.2963 2.328C14.1063 2.119 13.8383 2 13.5553 2H6.5553C5.1463 2 4.0003 3.122 4.0003 4.5V19.5C4.0003 20.878 5.1463 22 6.5553 22H17.4443C18.8533 22 20.0003 20.878 20.0003 19.5V9C20.0003 8.751 19.9073 8.512 19.7403 8.328Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Share-->
    <svg
      *ngSwitchCase="IconsType.Share"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 19C17.448 19 17 18.552 17 18C17 17.448 17.448 17 18 17C18.552 17 19 17.448 19 18C19 18.552 18.552 19 18 19ZM5 13C4.448 13 4 12.552 4 12C4 11.448 4.448 11 5 11C5.552 11 6 11.448 6 12C6 12.552 5.552 13 5 13ZM18 5C18.552 5 19 5.448 19 6C19 6.552 18.552 7 18 7C17.448 7 17 6.552 17 6C17 5.448 17.448 5 18 5ZM18 15C17.183 15 16.443 15.33 15.901 15.861L7.966 12.335C7.979 12.224 8 12.114 8 12C8 11.886 7.979 11.776 7.966 11.665L15.901 8.139C16.443 8.67 17.183 9 18 9C19.654 9 21 7.654 21 6C21 4.346 19.654 3 18 3C16.346 3 15 4.346 15 6C15 6.114 15.021 6.224 15.034 6.335L7.099 9.861C6.557 9.33 5.817 9 5 9C3.346 9 2 10.346 2 12C2 13.654 3.346 15 5 15C5.817 15 6.557 14.67 7.099 14.139L15.034 17.665C15.021 17.776 15 17.886 15 18C15 19.654 16.346 21 18 21C19.654 21 21 19.654 21 18C21 16.346 19.654 15 18 15Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Bar Chart-->
    <svg
      *ngSwitchCase="IconsType.BarChart"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 4C11.45 4 11 4.45 11 5V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V5C13 4.45 12.55 4 12 4ZM19 12C18.45 12 18 12.45 18 13V20C18 20.55 18.45 21 19 21C19.55 21 20 20.55 20 20V13C20 12.45 19.55 12 19 12ZM4 9C4 8.45 4.45 8 5 8C5.55 8 6 8.45 6 9V20C6 20.55 5.55 21 5 21C4.45 21 4 20.55 4 20V9Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Layout-->
    <svg
      *ngSwitchCase="IconsType.Layout"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 19H13V10H19V18C19 18.552 18.551 19 18 19ZM5 18V10H11V19H6C5.449 19 5 18.552 5 18ZM6 5H18C18.551 5 19 5.448 19 6V8H5V6C5 5.448 5.449 5 6 5ZM18 3H6C4.346 3 3 4.346 3 6V8.818V9.182V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V9.182V8.818V6C21 4.346 19.654 3 18 3Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Options-->
    <svg
      *ngSwitchCase="IconsType.Options"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 19C10.448 19 10 18.552 10 18C10 17.448 10.448 17 11 17C11.552 17 12 17.448 12 18C12 18.552 11.552 19 11 19ZM21 17H13.815C13.401 15.839 12.302 15 11 15C9.698 15 8.599 15.839 8.185 17H3C2.447 17 2 17.447 2 18C2 18.553 2.447 19 3 19H8.185C8.599 20.161 9.698 21 11 21C12.302 21 13.401 20.161 13.815 19H21C21.553 19 22 18.553 22 18C22 17.447 21.553 17 21 17ZM19 13C18.448 13 18 12.552 18 12C18 11.448 18.448 11 19 11C19.552 11 20 11.448 20 12C20 12.552 19.552 13 19 13ZM19 9C17.698 9 16.599 9.839 16.185 11H3C2.447 11 2 11.447 2 12C2 12.553 2.447 13 3 13H16.185C16.599 14.161 17.698 15 19 15C20.654 15 22 13.654 22 12C22 10.346 20.654 9 19 9ZM7 5C7.552 5 8 5.448 8 6C8 6.552 7.552 7 7 7C6.448 7 6 6.552 6 6C6 5.448 6.448 5 7 5ZM3 7H4.185C4.599 8.161 5.698 9 7 9C8.302 9 9.401 8.161 9.815 7H21C21.553 7 22 6.553 22 6C22 5.447 21.553 5 21 5H9.815C9.401 3.839 8.302 3 7 3C5.698 3 4.599 3.839 4.185 5H3C2.447 5 2 5.447 2 6C2 6.553 2.447 7 3 7Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Cloud Upload-->
    <svg
      *ngSwitchCase="IconsType.CloudUpload"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9998 2.99988C14.5808 2.99988 16.8548 4.66088 17.6748 7.04488C20.1138 7.37588 21.9998 9.47188 21.9998 11.9999C21.9998 13.2209 21.5558 14.3959 20.7498 15.3089C20.5518 15.5319 20.2768 15.6469 19.9998 15.6469C19.7648 15.6469 19.5288 15.5649 19.3378 15.3969C18.9248 15.0299 18.8848 14.3989 19.2508 13.9839C19.7338 13.4379 19.9998 12.7319 19.9998 11.9999C19.9998 10.3459 18.6538 8.99988 16.9998 8.99988H16.8998C16.4238 8.99988 16.0138 8.66388 15.9198 8.19688C15.5458 6.34488 13.8978 4.99988 11.9998 4.99988C10.1028 4.99988 8.45379 6.34488 8.08079 8.19688C7.98679 8.66388 7.57579 8.99988 7.09979 8.99988H6.99979C5.34579 8.99988 3.99979 10.3459 3.99979 11.9999C3.99979 12.7319 4.26579 13.4379 4.74979 13.9839C5.11479 14.3989 5.07579 15.0299 4.66179 15.3969C4.24779 15.7629 3.61579 15.7219 3.25079 15.3089C2.44379 14.3959 1.99979 13.2209 1.99979 11.9999C1.99979 9.47188 3.88579 7.37588 6.32479 7.04488C7.14579 4.66088 9.41979 2.99988 11.9998 2.99988ZM11.305 11.28C11.699 10.904 12.322 10.907 12.707 11.293L15.707 14.293C16.098 14.684 16.098 15.316 15.707 15.707C15.512 15.902 15.256 16 15 16C14.744 16 14.488 15.902 14.293 15.707L13 14.414V20C13 20.553 12.552 21 12 21C11.448 21 11 20.553 11 20V14.356L9.69499 15.616C9.29799 16.001 8.66499 15.988 8.28099 15.591C7.89699 15.193 7.90799 14.561 8.30499 14.177L11.305 11.28Z"
        [attr.fill]="color"
      ></path>
    </svg>
    <!--  Plus-->
    <svg
      *ngSwitchCase="IconsType.Plus"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        [attr.fill]="color"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 11H13V5C13 4.447 12.552 4 12 4C11.448 4 11 4.447 11 5V11H5C4.448 11 4 11.447 4 12C4 12.553 4.448 13 5 13H11V19C11 19.553 11.448 20 12 20C12.552 20 13 19.553 13 19V13H19C19.552 13 20 12.553 20 12C20 11.447 19.552 11 19 11Z"
        fill="#023665"
      />
    </svg>

    <!--Monitor-->
    <svg
      *ngSwitchCase="IconsType.Monitor"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 14C20 14.551 19.552 15 19 15H12.087H11.913H5C4.448 15 4 14.551 4 14V6C4 5.449 4.448 5 5 5H19C19.552 5 20 5.449 20 6V14ZM19 3H5C3.346 3 2 4.346 2 6V14C2 15.654 3.346 17 5 17H11V19H7C6.45 19 6 19.45 6 20C6 20.55 6.45 21 7 21H17C17.55 21 18 20.55 18 20C18 19.45 17.55 19 17 19H13V17H19C20.654 17 22 15.654 22 14V6C22 4.346 20.654 3 19 3Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Email-->
    <svg
      *ngSwitchCase="IconsType.Email"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 18H5C4.449 18 4 17.552 4 17V7.25L11.4 12.8C11.578 12.934 11.789 13 12 13C12.211 13 12.422 12.934 12.6 12.8L20 7.25V17C20 17.552 19.551 18 19 18ZM18.333 6L12 10.75L5.667 6H18.333ZM19 4H5C3.346 4 2 5.346 2 7V17C2 18.654 3.346 20 5 20H19C20.654 20 22 18.654 22 17V7C22 5.346 20.654 4 19 4Z"
        [attr.fill]="color"
      ></path>
    </svg>
    <!--MinusCircle-->
    <svg
      *ngSwitchCase="IconsType.MinusCircle"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 13H9C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11H15C15.55 11 16 11.45 16 12C16 12.55 15.55 13 15 13ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--More Vertical-->
    <svg
      *ngSwitchCase="IconsType.MoreVertical"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 7C13.104 7 14 6.104 14 5C14 3.896 13.104 3 12 3C10.896 3 10 3.896 10 5C10 6.104 10.896 7 12 7ZM12 10C10.896 10 10 10.896 10 12C10 13.104 10.896 14 12 14C13.104 14 14 13.104 14 12C14 10.896 13.104 10 12 10ZM10 19C10 17.896 10.896 17 12 17C13.104 17 14 17.896 14 19C14 20.104 13.104 21 12 21C10.896 21 10 20.104 10 19Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Edit-2-->
    <svg
      *ngSwitchCase="IconsType.Edit2"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9831 7.3233L6.36614 12.9403L6.10214 15.8963L9.07914 15.6253L14.6791 10.0193L11.9831 7.3233ZM17.9661 6.7293L15.2711 4.0353L13.3231 5.9833L16.0181 8.6793L17.9661 6.7293ZM5.09114 17.9963C5.06014 17.9993 5.03014 18.0003 5.00014 18.0003C4.73614 18.0003 4.48114 17.8963 4.29314 17.7073C4.08314 17.4973 3.97714 17.2053 4.00414 16.9103L4.38314 12.7393C4.42514 12.2823 4.62714 11.8513 4.95214 11.5263L13.9481 2.5293C14.6501 1.8253 15.9241 1.8603 16.6641 2.5993L19.4021 5.3373H19.4031C20.1691 6.1043 20.1991 7.3213 19.4711 8.0513L10.4741 17.0483C10.1491 17.3743 9.71914 17.5753 9.26114 17.6173L5.09114 17.9963ZM5 20.0004H19C19.55 20.0004 20 20.4504 20 21.0004C20 21.5504 19.55 22.0004 19 22.0004H5C4.45 22.0004 4 21.5504 4 21.0004C4 20.4504 4.45 20.0004 5 20.0004Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Trash-->
    <svg
      *ngSwitchCase="IconsType.Trash"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 19C18 19.551 17.552 20 17 20H7C6.448 20 6 19.551 6 19V8H18V19ZM10 4.328C10 4.173 10.214 4 10.5 4H13.5C13.786 4 14 4.173 14 4.328V6H10V4.328ZM21 6H20H16V4.328C16 3.044 14.879 2 13.5 2H10.5C9.121 2 8 3.044 8 4.328V6H4H3C2.45 6 2 6.45 2 7C2 7.55 2.45 8 3 8H4V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V8H21C21.55 8 22 7.55 22 7C22 6.45 21.55 6 21 6Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!-- Crop -->
    <svg
      *ngSwitchCase="IconsType.Crop"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.55569 14C6.24969 14 5.99969 13.751 5.99969 13.444V6H13.4447C13.7507 6 13.9997 6.249 13.9997 6.556V14H6.55569ZM18.9997 14H15.9997V6.556C15.9997 5.146 14.8537 4 13.4447 4H5.99969V1C5.99969 0.447 5.55269 0 4.99969 0C4.44769 0 3.99969 0.447 3.99969 1V4H0.999695C0.447695 4 -0.000305176 4.447 -0.000305176 5C-0.000305176 5.553 0.447695 6 0.999695 6H3.99969V13.444C3.99969 14.854 5.1467 16 6.5557 16H13.9997V19C13.9997 19.553 14.4477 20 14.9997 20C15.5527 20 15.9997 19.553 15.9997 19V16H18.9997C19.5527 16 19.9997 15.553 19.9997 15C19.9997 14.447 19.5527 14 18.9997 14Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!-- Move -->
    <svg
      *ngSwitchCase="IconsType.Move"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.709 9.30763L16.709 6.29463C16.319 5.90363 15.685 5.90063 15.295 6.29163C14.903 6.68163 14.901 7.31363 15.291 7.70563L16.58 8.99963H11V3.40863L12.291 4.70563C12.486 4.90163 12.743 4.99963 13 4.99963C13.255 4.99963 13.511 4.90263 13.706 4.70863C14.097 4.31863 14.099 3.68563 13.709 3.29463L10.722 0.294634C10.533 0.105634 10.315 0.00863379 10.013 -0.000366211C9.74801 -0.000366211 9.49401 0.104634 9.30701 0.291634L6.29401 3.29163C5.90301 3.68163 5.90101 4.31463 6.29101 4.70563C6.68001 5.09663 7.31301 5.09863 7.70601 4.70863L9.00001 3.41963V8.99963H3.40801L4.70501 7.70863C5.09701 7.31863 5.09901 6.68563 4.70901 6.29463C4.31901 5.90363 3.68501 5.90063 3.29501 6.29163L0.295007 9.27863C0.106007 9.46563 0.00100701 9.71963 7.0121e-06 9.98463C-0.000992988 10.2496 0.105007 10.5046 0.291007 10.6926L3.29101 13.7056C3.48601 13.9016 3.74301 13.9996 4.00001 13.9996C4.25501 13.9996 4.51101 13.9026 4.70501 13.7086C5.09701 13.3186 5.09901 12.6856 4.70901 12.2946L3.42001 10.9996H9.00001V16.5916L7.70901 15.2946C7.31901 14.9026 6.68601 14.9006 6.29401 15.2916C5.90301 15.6816 5.90101 16.3146 6.29101 16.7056L9.27801 19.7056C9.46601 19.8936 9.72001 19.9996 9.98501 19.9996H9.98701C10.252 19.9996 10.506 19.8946 10.693 19.7086L13.706 16.7086C14.097 16.3186 14.099 15.6856 13.709 15.2946C13.319 14.9026 12.686 14.9006 12.294 15.2916L11 16.5796V10.9996H16.592L15.295 12.2916C14.903 12.6816 14.901 13.3136 15.291 13.7056C15.486 13.9016 15.743 13.9996 16 13.9996C16.255 13.9996 16.511 13.9026 16.705 13.7086L19.705 10.7216C19.894 10.5346 19.999 10.2806 20 10.0156C20.001 9.74963 19.896 9.49563 19.709 9.30763Z"
        [attr.fill]="color"
      ></path>
    </svg>

<!--    &lt;!&ndash; RotateRight &ndash;&gt;-->
<!--    <svg-->
<!--      *ngSwitchCase="IconsType.RotateRight"-->
<!--      width="18"-->
<!--      height="18"-->
<!--      viewBox="0 0 18 18"-->
<!--      fill="none"-->
<!--      xmlns="http://www.w3.org/2000/svg"-->
<!--    >-->
<!--      <path-->
<!--        fill-rule="evenodd"-->
<!--        clip-rule="evenodd"-->
<!--        d="M17.3032 10.4258C16.7772 10.2588 16.2152 10.5498 16.0472 11.0758C15.1102 14.0218 12.3522 15.9998 9.18421 15.9998C5.22221 15.9998 2.00021 12.8598 2.00021 8.99982C2.00021 5.14082 5.22221 1.99982 9.18421 1.99982C10.9122 1.99982 12.5422 2.60182 13.8292 3.66982L11.6632 3.31282C11.1132 3.21282 10.6032 3.59182 10.5132 4.13582C10.4232 4.68082 10.7922 5.19582 11.3372 5.28482L15.5832 5.98682C15.6382 5.99582 15.6942 5.99982 15.7472 5.99982C15.8662 5.99982 15.9822 5.97882 16.0902 5.93882C16.1272 5.92482 16.1572 5.89882 16.1932 5.87982C16.2592 5.84582 16.3282 5.81582 16.3852 5.76782C16.4212 5.73882 16.4442 5.69682 16.4752 5.66282C16.5222 5.61382 16.5722 5.56682 16.6072 5.50682C16.6322 5.46382 16.6422 5.41282 16.6612 5.36482C16.6852 5.30582 16.7172 5.25082 16.7292 5.18582L17.4832 1.18582C17.5852 0.642817 17.2282 0.118817 16.6852 0.0178169C16.1442 -0.0801831 15.6192 0.272817 15.5172 0.814817L15.2452 2.25582C13.5812 0.814817 11.4482 -0.000183105 9.18421 -0.000183105C4.12021 -0.000183105 0.000213623 4.03682 0.000213623 8.99982C0.000213623 13.9628 4.12021 17.9998 9.18421 17.9998C13.2262 17.9998 16.7502 15.4608 17.9532 11.6818C18.1202 11.1558 17.8292 10.5938 17.3032 10.4258Z"-->
<!--        [attr.fill]="color"-->
<!--      ></path>-->
<!--    </svg>-->

<!--    &lt;!&ndash; RotateLeft &ndash;&gt;-->
<!--    <svg-->
<!--      *ngSwitchCase="IconsType.RotateLeft"-->
<!--      width="18"-->
<!--      height="18"-->
<!--      viewBox="0 0 18 18"-->
<!--      fill="none"-->
<!--      style="transform: scale(1, -1) rotate(-180deg)"-->
<!--      xmlns="http://www.w3.org/2000/svg"-->
<!--    >-->
<!--      <path-->
<!--        fill-rule="evenodd"-->
<!--        clip-rule="evenodd"-->
<!--        d="M17.3032 10.4258C16.7772 10.2588 16.2152 10.5498 16.0472 11.0758C15.1102 14.0218 12.3522 15.9998 9.18421 15.9998C5.22221 15.9998 2.00021 12.8598 2.00021 8.99982C2.00021 5.14082 5.22221 1.99982 9.18421 1.99982C10.9122 1.99982 12.5422 2.60182 13.8292 3.66982L11.6632 3.31282C11.1132 3.21282 10.6032 3.59182 10.5132 4.13582C10.4232 4.68082 10.7922 5.19582 11.3372 5.28482L15.5832 5.98682C15.6382 5.99582 15.6942 5.99982 15.7472 5.99982C15.8662 5.99982 15.9822 5.97882 16.0902 5.93882C16.1272 5.92482 16.1572 5.89882 16.1932 5.87982C16.2592 5.84582 16.3282 5.81582 16.3852 5.76782C16.4212 5.73882 16.4442 5.69682 16.4752 5.66282C16.5222 5.61382 16.5722 5.56682 16.6072 5.50682C16.6322 5.46382 16.6422 5.41282 16.6612 5.36482C16.6852 5.30582 16.7172 5.25082 16.7292 5.18582L17.4832 1.18582C17.5852 0.642817 17.2282 0.118817 16.6852 0.0178169C16.1442 -0.0801831 15.6192 0.272817 15.5172 0.814817L15.2452 2.25582C13.5812 0.814817 11.4482 -0.000183105 9.18421 -0.000183105C4.12021 -0.000183105 0.000213623 4.03682 0.000213623 8.99982C0.000213623 13.9628 4.12021 17.9998 9.18421 17.9998C13.2262 17.9998 16.7502 15.4608 17.9532 11.6818C18.1202 11.1558 17.8292 10.5938 17.3032 10.4258Z"-->
<!--        [attr.fill]="color"-->
<!--      ></path>-->
<!--    </svg>-->

    <!-- Chevron Up -->
    <svg
      *ngSwitchCase="IconsType.ChevronUp"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 14.5C15.744 14.5 15.488 14.402 15.293 14.207L11.988 10.902L8.695 14.082C8.297 14.466 7.665 14.456 7.281 14.057C6.897 13.66 6.908 13.026 7.305 12.643L11.305 8.781C11.698 8.402 12.322 8.407 12.707 8.793L16.707 12.793C17.098 13.184 17.098 13.816 16.707 14.207C16.512 14.402 16.256 14.5 16 14.5Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!-- Chevron Down -->
    <svg
      *ngSwitchCase="IconsType.ChevronDown"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 15.5C11.744 15.5 11.488 15.402 11.293 15.207L7.29301 11.207C6.90201 10.816 6.90201 10.184 7.29301 9.79301C7.68401 9.40201 8.31601 9.40201 8.70701 9.79301L12.012 13.098L15.305 9.91801C15.704 9.53501 16.335 9.54601 16.719 9.94301C17.103 10.34 17.092 10.974 16.695 11.357L12.695 15.219C12.5 15.407 12.25 15.5 12 15.5Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!-- Arrow Ios Down -->
    <svg
      *ngSwitchCase="IconsType.ArrowIosDown"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 16C11.772 16 11.545 15.923 11.36 15.768L5.35997 10.768C4.93597 10.415 4.87797 9.78398 5.23197 9.35998C5.58497 8.93598 6.21497 8.87898 6.63997 9.23198L12.011 13.708L17.373 9.39298C17.803 9.04698 18.433 9.11498 18.779 9.54498C19.125 9.97498 19.057 10.604 18.627 10.951L12.627 15.779C12.444 15.926 12.222 16 12 16Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!-- Arrow Ios Up -->
    <svg
      *ngSwitchCase="IconsType.ArrowIosUp"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.9995 15C17.7735 15 17.5465 14.924 17.3595 14.768L11.9885 10.292L6.62651 14.607C6.19751 14.954 5.56751 14.886 5.22051 14.455C4.87451 14.025 4.94251 13.396 5.37351 13.049L11.3735 8.22104C11.7435 7.92204 12.2745 7.92604 12.6405 8.23204L18.6405 13.232C19.0645 13.585 19.1215 14.216 18.7685 14.64C18.5705 14.877 18.2865 15 17.9995 15"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--  Phone-->
    <svg
      *ngSwitchCase="IconsType.Phone"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.60009 4C5.16609 4 4.00009 5.166 4.00009 6.6C4.00009 13.988 10.0111 20 17.4001 20C18.8331 20 20.0001 18.834 20.0001 17.4C20.0001 17.289 19.9931 17.18 19.9791 17.072L15.3591 16.012C15.2671 16.188 15.1661 16.379 15.0741 16.557C14.6181 17.427 14.2881 18.059 13.4461 17.72C10.1401 16.56 7.44109 13.86 6.26609 10.514C5.90909 9.729 6.58909 9.373 7.45109 8.923C7.62609 8.831 7.81509 8.732 7.98809 8.642L6.92809 4.021C6.81709 4.007 6.70909 4 6.60009 4ZM17.4001 22C8.90809 22 2.00009 15.092 2.00009 6.6C2.00009 4.063 4.06309 2 6.60009 2C6.86009 2 7.11709 2.022 7.36609 2.065C7.60909 2.104 7.85309 2.166 8.09109 2.248C8.41609 2.361 8.66109 2.634 8.73809 2.97L10.1071 8.934C10.1831 9.262 10.0881 9.606 9.85409 9.85C9.71809 9.992 9.71509 9.995 8.47509 10.644C9.47909 12.818 11.2241 14.557 13.3541 15.527C14.0041 14.286 14.0081 14.282 14.1501 14.146C14.3941 13.912 14.7401 13.821 15.0661 13.893L21.0311 15.262C21.3661 15.339 21.6391 15.583 21.7511 15.908C21.8331 16.144 21.8951 16.388 21.9361 16.639C21.9781 16.886 22.0001 17.142 22.0001 17.4C22.0001 19.937 19.9361 22 17.4001 22Z"
        [attr.fill]="color"
      ></path>
    </svg>
      <!--  edit-->
    <svg
      *ngSwitchCase="IconsType.Edit"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0186 10.6787L13.3236 7.98367L15.2716 6.03467L17.9656 8.72867L16.0186 10.6787ZM9.07959 17.6247L6.10259 17.8957L6.36659 14.9397L11.9836 9.32267L14.6796 12.0187L9.07959 17.6247ZM19.4036 7.33767L19.4026 7.33667L16.6646 4.59867C15.9236 3.85967 14.6506 3.82467 13.9486 4.52967L4.95259 13.5257C4.62659 13.8507 4.42459 14.2827 4.38259 14.7397L4.00359 18.9097C3.97759 19.2047 4.08259 19.4967 4.29259 19.7067C4.48159 19.8957 4.73659 19.9997 4.99959 19.9997C5.03059 19.9997 5.06059 19.9987 5.09059 19.9957L9.26059 19.6167C9.71859 19.5747 10.1496 19.3737 10.4746 19.0487L19.4716 10.0517C20.1996 9.32167 20.1686 8.10367 19.4036 7.33767Z"
        [attr.fill]="color"
      ></path>
    </svg>

      <!-- Arrow Left -->
    <svg
      *ngSwitchCase="IconsType.ArrowIosLeft"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 11H7.135L10.768 6.64003C11.122 6.21603 11.064 5.58503 10.64 5.23203C10.215 4.87803 9.585 4.93603 9.232 5.36003L4.232 11.36C4.193 11.407 4.173 11.462 4.144 11.514C4.12 11.556 4.091 11.592 4.073 11.638C4.028 11.753 4.001 11.874 4.001 11.996C4.001 11.997 4 11.999 4 12C4 12.001 4.001 12.003 4.001 12.004C4.001 12.126 4.028 12.247 4.073 12.362C4.091 12.408 4.12 12.444 4.144 12.486C4.173 12.538 4.193 12.593 4.232 12.64L9.232 18.64C9.43 18.877 9.714 19 10 19C10.226 19 10.453 18.924 10.64 18.768C11.064 18.415 11.122 17.784 10.768 17.36L7.135 13H19C19.552 13 20 12.552 20 12C20 11.448 19.552 11 19 11"
        [attr.fill]="color"
      ></path>
    </svg>

      <!-- RotateRight -->
    <svg
      *ngSwitchCase="IconsType.RotateRight"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3032 10.4258C16.7772 10.2588 16.2152 10.5498 16.0472 11.0758C15.1102 14.0218 12.3522 15.9998 9.18421 15.9998C5.22221 15.9998 2.00021 12.8598 2.00021 8.99982C2.00021 5.14082 5.22221 1.99982 9.18421 1.99982C10.9122 1.99982 12.5422 2.60182 13.8292 3.66982L11.6632 3.31282C11.1132 3.21282 10.6032 3.59182 10.5132 4.13582C10.4232 4.68082 10.7922 5.19582 11.3372 5.28482L15.5832 5.98682C15.6382 5.99582 15.6942 5.99982 15.7472 5.99982C15.8662 5.99982 15.9822 5.97882 16.0902 5.93882C16.1272 5.92482 16.1572 5.89882 16.1932 5.87982C16.2592 5.84582 16.3282 5.81582 16.3852 5.76782C16.4212 5.73882 16.4442 5.69682 16.4752 5.66282C16.5222 5.61382 16.5722 5.56682 16.6072 5.50682C16.6322 5.46382 16.6422 5.41282 16.6612 5.36482C16.6852 5.30582 16.7172 5.25082 16.7292 5.18582L17.4832 1.18582C17.5852 0.642817 17.2282 0.118817 16.6852 0.0178169C16.1442 -0.0801831 15.6192 0.272817 15.5172 0.814817L15.2452 2.25582C13.5812 0.814817 11.4482 -0.000183105 9.18421 -0.000183105C4.12021 -0.000183105 0.000213623 4.03682 0.000213623 8.99982C0.000213623 13.9628 4.12021 17.9998 9.18421 17.9998C13.2262 17.9998 16.7502 15.4608 17.9532 11.6818C18.1202 11.1558 17.8292 10.5938 17.3032 10.4258Z"
        [attr.fill]="color"
      ></path>
    </svg>

      <!-- RotateLeft -->
    <svg
      *ngSwitchCase="IconsType.RotateLeft"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      style="transform: scale(1, -1) rotate(-180deg)" xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3032 10.4258C16.7772 10.2588 16.2152 10.5498 16.0472 11.0758C15.1102 14.0218 12.3522 15.9998 9.18421 15.9998C5.22221 15.9998 2.00021 12.8598 2.00021 8.99982C2.00021 5.14082 5.22221 1.99982 9.18421 1.99982C10.9122 1.99982 12.5422 2.60182 13.8292 3.66982L11.6632 3.31282C11.1132 3.21282 10.6032 3.59182 10.5132 4.13582C10.4232 4.68082 10.7922 5.19582 11.3372 5.28482L15.5832 5.98682C15.6382 5.99582 15.6942 5.99982 15.7472 5.99982C15.8662 5.99982 15.9822 5.97882 16.0902 5.93882C16.1272 5.92482 16.1572 5.89882 16.1932 5.87982C16.2592 5.84582 16.3282 5.81582 16.3852 5.76782C16.4212 5.73882 16.4442 5.69682 16.4752 5.66282C16.5222 5.61382 16.5722 5.56682 16.6072 5.50682C16.6322 5.46382 16.6422 5.41282 16.6612 5.36482C16.6852 5.30582 16.7172 5.25082 16.7292 5.18582L17.4832 1.18582C17.5852 0.642817 17.2282 0.118817 16.6852 0.0178169C16.1442 -0.0801831 15.6192 0.272817 15.5172 0.814817L15.2452 2.25582C13.5812 0.814817 11.4482 -0.000183105 9.18421 -0.000183105C4.12021 -0.000183105 0.000213623 4.03682 0.000213623 8.99982C0.000213623 13.9628 4.12021 17.9998 9.18421 17.9998C13.2262 17.9998 16.7502 15.4608 17.9532 11.6818C18.1202 11.1558 17.8292 10.5938 17.3032 10.4258Z"
        [attr.fill]="color"
      ></path>
    </svg>

      <!-- MoveTickets -->
    <svg
      *ngSwitchCase="IconsType.MoveTickets"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="16"
        cy="16"
        r="16"
        fill="#E4E7EB"/>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.8333 10.1739V16.4991V21.1487L17.9115 20.0755C18.2381 19.7497 18.7656 19.7513 19.0906 20.078C19.4155 20.4038 19.4139 20.9312 19.0881 21.2562L16.5775 23.7559C16.4216 23.9109 16.21 23.9984 15.9892 23.9984H15.9875C15.7667 23.9984 15.5551 23.9101 15.3984 23.7534L12.9095 21.2537C12.5845 20.9279 12.5862 20.4004 12.912 20.0755C13.2386 19.7497 13.7661 19.7513 14.091 20.078L15.1668 21.1587V16.4991V10.1831L14.0885 11.2571C13.7611 11.5821 13.2336 11.5804 12.9095 11.2546C12.5845 10.9288 12.5862 10.4014 12.912 10.0764L15.4226 7.57665C15.5784 7.42083 15.79 7.33334 16.0109 7.33334C16.2625 7.34084 16.4441 7.42166 16.6016 7.57915L19.0906 10.0789C19.4155 10.4047 19.4139 10.9322 19.0881 11.2571C18.9256 11.4188 18.7123 11.4996 18.4998 11.4996C18.2856 11.4996 18.0715 11.4179 17.909 11.2546L16.8333 10.1739Z"
        fill="#0064BE"
      ></path>
    </svg>

    <!--Search-->
    <svg
      *ngSwitchCase="IconsType.Search"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 11C5 7.691 7.691 5 11 5C14.309 5 17 7.691 17 11C17 14.309 14.309 17 11 17C7.691 17 5 14.309 5 11ZM20.707 19.293L17.312 15.897C18.365 14.543 19 12.846 19 11C19 6.589 15.411 3 11 3C6.589 3 3 6.589 3 11C3 15.411 6.589 19 11 19C12.846 19 14.543 18.365 15.897 17.312L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Sort-->
    <svg
      *ngSwitchCase="IconsType.Sort"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0015 18.9962C11.6644 18.9962 11.3419 18.841 11.1181 18.5685L8.31118 15.172C7.9754 14.7649 7.90811 14.1872 8.13863 13.6989C8.34183 13.2678 8.74624 13 9.19462 13H14.8084C15.2568 13 15.6612 13.2678 15.8644 13.6989C16.0949 14.1872 16.0276 14.7649 15.6925 15.1713L12.8849 18.5685C12.6611 18.841 12.3386 18.9962 12.0015 18.9962Z"
        fill="#798594"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0015 5C11.6644 5 11.3419 5.15523 11.1181 5.42773L8.31118 8.82424C7.9754 9.23131 7.90811 9.80895 8.13863 10.2973C8.34183 10.7284 8.74624 10.9962 9.19462 10.9962H14.8084C15.2568 10.9962 15.6612 10.7284 15.8644 10.2973C16.0949 9.80895 16.0276 9.23131 15.6925 8.82491L12.8849 5.42773C12.6611 5.15523 12.3386 5 12.0015 5Z"
        fill="#798594"
      ></path>
    </svg>

    <!--Sort Ascending-->
    <svg
      *ngSwitchCase="IconsType.SortAscending"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0015 18.9962C11.6644 18.9962 11.3419 18.841 11.1181 18.5685L8.31118 15.172C7.9754 14.7649 7.90811 14.1872 8.13863 13.6989C8.34183 13.2678 8.74624 13 9.19462 13H14.8084C15.2568 13 15.6612 13.2678 15.8644 13.6989C16.0949 14.1872 16.0276 14.7649 15.6925 15.1713L12.8849 18.5685C12.6611 18.841 12.3386 18.9962 12.0015 18.9962Z"
        [attr.fill]="color"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0015 5C11.6644 5 11.3419 5.15523 11.1181 5.42773L8.31118 8.82424C7.9754 9.23131 7.90811 9.80895 8.13863 10.2973C8.34183 10.7284 8.74624 10.9962 9.19462 10.9962H14.8084C15.2568 10.9962 15.6612 10.7284 15.8644 10.2973C16.0949 9.80895 16.0276 9.23131 15.6925 8.82491L12.8849 5.42773C12.6611 5.15523 12.3386 5 12.0015 5Z"
        fill="#798594"
      ></path>
    </svg>

    <!--Sort Descending-->
    <svg
      *ngSwitchCase="IconsType.SortDescending"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0015 18.9962C11.6644 18.9962 11.3419 18.841 11.1181 18.5685L8.31118 15.172C7.9754 14.7649 7.90811 14.1872 8.13863 13.6989C8.34183 13.2678 8.74624 13 9.19462 13H14.8084C15.2568 13 15.6612 13.2678 15.8644 13.6989C16.0949 14.1872 16.0276 14.7649 15.6925 15.1713L12.8849 18.5685C12.6611 18.841 12.3386 18.9962 12.0015 18.9962Z"
        fill="#798594"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0015 5C11.6644 5 11.3419 5.15523 11.1181 5.42773L8.31118 8.82424C7.9754 9.23131 7.90811 9.80895 8.13863 10.2973C8.34183 10.7284 8.74624 10.9962 9.19462 10.9962H14.8084C15.2568 10.9962 15.6612 10.7284 15.8644 10.2973C16.0949 9.80895 16.0276 9.23131 15.6925 8.82491L12.8849 5.42773C12.6611 5.15523 12.3386 5 12.0015 5Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Funnel 2-->
    <svg
      *ngSwitchCase="IconsType.Funnel2"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9033 22C13.6893 22 13.4773 21.932 13.3003 21.797L9.27432 18.752C9.02432 18.563 8.87732 18.268 8.87732 17.955V14.681L4.11132 5.459C3.95132 5.149 3.96432 4.778 4.14632 4.48C4.32732 4.182 4.65132 4 5.00032 4H19.0003C19.3523 4 19.6783 4.185 19.8593 4.488C20.0393 4.79 20.0473 5.166 19.8803 5.475L14.9033 14.69V21C14.9033 21.379 14.6883 21.726 14.3483 21.896C14.2073 21.965 14.0553 22 13.9033 22"
        [attr.fill]="color"
      ></path>
    </svg>

    <svg
      *ngSwitchCase="IconsType.Sync"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.6829 10.3261C21.6756 10.3419 21.6684 10.3578 21.6616 10.374C21.6547 10.3908 21.6493 10.4082 21.6439 10.4257C21.6352 10.454 21.6264 10.4822 21.6116 10.507C21.582 10.556 21.5434 10.5972 21.5046 10.6385C21.4935 10.6502 21.4825 10.662 21.4716 10.674C21.4595 10.6865 21.4488 10.7003 21.4381 10.714C21.4231 10.7331 21.4082 10.7523 21.3896 10.768C21.3336 10.8137 21.2689 10.8455 21.2044 10.8772C21.1998 10.8795 21.1952 10.8817 21.1906 10.884C21.177 10.8906 21.164 10.8989 21.151 10.9073C21.1326 10.9191 21.1141 10.931 21.0936 10.938C20.9856 10.978 20.8706 11 20.7516 11C20.6976 11 20.6416 10.996 20.5866 10.986L16.3366 10.281C15.7916 10.191 15.4236 9.676 15.5136 9.131C15.6036 8.587 16.1176 8.214 16.6636 8.309L18.3076 8.581C17.0626 6.395 14.6856 5 12.0696 5C9.11059 5 6.50359 6.718 5.42659 9.375C5.26959 9.765 4.89459 10 4.49959 10C4.37459 10 4.24759 9.977 4.12459 9.927C3.61259 9.72 3.36559 9.137 3.57359 8.625C4.95759 5.208 8.29259 3 12.0696 3C15.4816 3 18.5826 4.87 20.1476 7.788L20.5166 5.815C20.6186 5.273 21.1426 4.914 21.6836 5.018C22.2266 5.119 22.5846 5.642 22.4826 6.185L21.7336 10.185C21.724 10.236 21.7034 10.281 21.6829 10.3261ZM18.5735 14.6252C18.7805 14.1122 19.3645 13.8662 19.8755 14.0732C20.3875 14.2802 20.6345 14.8632 20.4265 15.3752C19.0425 18.7922 15.7075 21.0002 11.9305 21.0002C8.51849 21.0002 5.41749 19.1302 3.85249 16.2122L3.48249 18.1842C3.39349 18.6652 2.97349 19.0002 2.50049 19.0002C2.43949 19.0002 2.37749 18.9942 2.31549 18.9822C1.77249 18.8812 1.41549 18.3582 1.51749 17.8152L2.26649 13.8152C2.27409 13.7759 2.29092 13.7411 2.30783 13.706C2.31761 13.6858 2.32742 13.6655 2.33549 13.6442C2.34339 13.6243 2.3503 13.6037 2.35722 13.583C2.37217 13.5383 2.38719 13.4935 2.41249 13.4552C2.42724 13.4324 2.44654 13.4142 2.46596 13.3959C2.47811 13.3844 2.49032 13.3729 2.50149 13.3602C2.51029 13.35 2.519 13.3397 2.5277 13.3295C2.57529 13.2734 2.62246 13.2178 2.68249 13.1772C2.68838 13.1729 2.69543 13.1703 2.70239 13.1678C2.70842 13.1656 2.71438 13.1634 2.71949 13.1602C2.81649 13.0972 2.92049 13.0482 3.03549 13.0232C3.04249 13.0216 3.04978 13.022 3.05706 13.0224C3.06328 13.0228 3.06949 13.0231 3.07549 13.0222C3.18549 13.0042 3.29649 12.9932 3.41349 13.0132L7.66349 13.7192C8.20849 13.8082 8.57649 14.3242 8.48649 14.8692C8.40549 15.3582 7.98149 15.7052 7.50049 15.7052C7.44649 15.7052 7.39149 15.7012 7.33649 15.6912L5.69249 15.4192C6.93749 17.6052 9.31449 19.0002 11.9305 19.0002C14.8895 19.0002 17.4965 17.2822 18.5735 14.6252Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <svg
      *ngSwitchCase="IconsType.CheckMarkCircle"
      [attr.width]="width"
      [attr.height]="height"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7046 8.3945L10.9206 13.3635L9.2876 11.2775C8.9476 10.8415 8.3176 10.7655 7.8836 11.1065C7.4486 11.4465 7.3716 12.0755 7.7126 12.5095L10.1436 15.6165C10.3336 15.8585 10.6236 15.9995 10.9316 15.9995H10.9386C11.2476 15.9985 11.5396 15.8525 11.7266 15.6055L16.2956 9.6055C16.6306 9.1655 16.5456 8.5395 16.1056 8.2045C15.6646 7.8695 15.0386 7.9555 14.7046 8.3945ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.477 2 2 6.478 2 12C2 17.522 6.477 22 12 22C17.523 22 22 17.522 22 12C22 6.478 17.523 2 12 2Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <!--Minus-->
    <svg
      *ngSwitchCase="IconsType.Minus"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 13H5C4.448 13 4 12.553 4 12C4 11.447 4.448 11 5 11H19C19.553 11 20 11.447 20 12C20 12.553 19.553 13 19 13Z"
        [attr.fill]="color"
      ></path>
    </svg>

<!--    Info-->
    <svg
      *ngSwitchCase="IconsType.Info"
      [attr.width]="width"

      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 9C11.448 9 11 8.552 11 8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8C13 8.552 12.552 9 12 9ZM13 16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V11C11 10.448 11.448 10 12 10C12.552 10 13 10.448 13 11V16ZM12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.522 22 22 17.523 22 12C22 6.477 17.522 2 12 2Z"
        [attr.fill]="color"
      ></path>
    </svg>

    <svg
      *ngSwitchCase="IconsType.CheckMarkSquare"
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
    <path
            id="Mask"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19 12.8335C19 12.2815 19.448 11.8335 20 11.8335C20.552 11.8335 21 12.2815 21 12.8335V18.3995C21 19.8335 19.833 21.0005 18.4 21.0005H5.6C4.167 21.0005 3 19.8335 3 18.3995V5.60049C3 4.16649 4.167 3.00049 5.6 3.00049H15.167C15.719 3.00049 16.167 3.44749 16.167 4.00049C16.167 4.55249 15.719 5.00049 15.167 5.00049H5.6C5.269 5.00049 5 5.26949 5 5.60049V18.3995C5 18.7305 5.269 19.0005 5.6 19.0005H18.4C18.731 19.0005 19 18.7305 19 18.3995V12.8335ZM9.3096 10.9465C9.7096 10.5645 10.3416 10.5805 10.7236 10.9795L12.2286 12.5575L18.2816 6.30449C18.6646 5.90849 19.2976 5.89649 19.6956 6.28149C20.0926 6.66549 20.1026 7.29849 19.7186 7.69549L12.9416 14.6955C12.7536 14.8905 12.4946 15.0005 12.2236 15.0005H12.2196C11.9476 14.9995 11.6876 14.8875 11.4996 14.6905L9.2766 12.3605C8.8946 11.9605 8.9106 11.3275 9.3096 10.9465Z"
            [attr.fill]="color"/>
</svg>


  </ng-container>
</span>
